import { ReactNode } from "react";
import { TranslationService } from "../../../services/TranslationService";
import ErrorMessage from "../../shared/components/Error";
import Loading from "../../shared/components/Loading";
import { UseAgendaResult } from "../hooks/useAgenda";
import AgendaEmptyState from "./AgendaEmptyState";
import AgendaGenerating from "./AgendaGenerating";

/** Resolves the page body: loading, error, generating, not generated, or content. */
const AgendaGate = ({
  state,
  children
}: {
  state: Pick<
    UseAgendaResult,
    | "agenda"
    | "loading"
    | "loadError"
    | "generating"
    | "canEdit"
    | "reload"
    | "generate"
  >;
  children: ReactNode;
}) => {
  if (state.loading) {
    return <Loading height={200} />;
  }
  if (state.generating) {
    return <AgendaGenerating />;
  }
  if (state.loadError || !state.agenda) {
    return (
      <ErrorMessage
        message={TranslationService.translate.ErrorLoadingData}
        onRefresh={state.reload}
      />
    );
  }
  if (!state.agenda.generated) {
    return (
      <AgendaEmptyState
        canGenerate={state.canEdit}
        onGenerate={state.generate}
      />
    );
  }
  return <>{children}</>;
};

export default AgendaGate;
